// Thin wrapper around window.MarketingVT exposed by the marketing-attribution
// script. Visitor identity (session + persistent), URL-param capture, _fbc/_fbp
// generation, and the canonical landing_page cookie are all owned by that
// script. This module exists only to give server/client code a single import
// path with an SSR-safe fallback when the script hasn't booted yet (or runs
// during prerender).
const VISITOR_ID_STORAGE_KEY = 'visitor_id';

export const getVisitorId = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  // Wrap storage access: sessionStorage throws SecurityError in Safari private
  // mode and other restricted contexts. Callers (WebAnalytics, InteractiveForm,
  // ExperimentsProvider) rely on this returning a safe fallback rather than
  // surfacing the error.
  try {
    return (
      window.MarketingVT?.getVisitorId?.() ||
      window.sessionStorage.getItem(VISITOR_ID_STORAGE_KEY) ||
      ''
    );
  } catch {
    return '';
  }
};
